import { preferredScrollBehavior } from '@/utils/scrollBehavior'
import { START_LOCATION, type RouterScrollBehavior } from 'vue-router'

export const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) return savedPosition

  if (from !== START_LOCATION && to.path === from.path && to.hash === from.hash) {
    return false
  }

  if (to.hash) return { el: to.hash, behavior: preferredScrollBehavior(), top: 60 }

  return { top: 0 }
}
